import React from 'react';
import FaqResultsSC from './faq-results.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import FaqBanner from '../../components/faq-banner';
import FaqResultsContent from '../../components/faq-results-content';

const FaqResults = () => {
  return (
    <FaqResultsSC>
      <InfoBanner>
        <FaqBanner />
      </InfoBanner>
      <ContentWrap>
        <FaqResultsContent />
      </ContentWrap>
    </FaqResultsSC>
  );
};

export default FaqResults;
